import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  MAT_DIALOG_DATA, MatDialog,
  MatDialogConfig, MatDialogRef
} from '@angular/material/dialog';
import { finalize, map } from 'rxjs/operators';

import { format, parse } from 'date-fns';

import {
  LanguageFormComponent, LanguageFormModel
} from 'entity/forms/language-form/language-form.component';

import {
  EntityTypeDetails, GetEntityById2GQL, Language, UpdateEntityBasicInfoGQL
} from 'generated/graphql';

/**
 * Format of data for the dialog
 */
export interface AddOrUpdateLanguageDialogData {
  entityId: string;
  campaignId: string;
}

@Component({
  selector: 'app-add-or-update-language',
  templateUrl: './add-or-update-language.dialog.html'
})
export class AddOrUpdateLanguageDialog implements OnInit {
  isSaving = false;

  /**
   * Set by dumb form component
   */
  formControl: FormControl<LanguageFormModel>;

  entityType: EntityTypeDetails.Fragment;

  static open(dialog: MatDialog, config: MatDialogConfig<AddOrUpdateLanguageDialogData>) {
    return dialog.open(AddOrUpdateLanguageDialog, config);
  }
  constructor(
    private _getEntityById2GQL: GetEntityById2GQL,
    private _updateEntityBasicInfoGQL: UpdateEntityBasicInfoGQL,
    private _cd: ChangeDetectorRef,
    public dialogRef: MatDialogRef<AddOrUpdateLanguageDialog>,
    @Inject(MAT_DIALOG_DATA) public data: AddOrUpdateLanguageDialogData
  ) { }

  ngOnInit(): void {
    this._getDataAndBuildForm();
  }

  onSaveClicked() {
    if (this.isSaving) {
      return;
    }
    this.isSaving = true;

    this._save$().pipe(
      finalize(() => this.isSaving = false)
    ).subscribe(({ data }) => {
      this.close(data.updateEntity);
    });
  }

  close(data: any = null) {
    this.dialogRef.close(data);
  }


  private _getDataAndBuildForm() {
    this._getEntityById2GQL.fetch({
      entityId: this.data.entityId,
      campaignId: this.data.campaignId
    }).pipe(
      map(({ data }) => data.getEntity)
    ).subscribe((entity) => {
      this.entityType = entity.entityType;
      console.log('Entity languages:', entity.entityLanguages);
      this.formControl = new FormControl<LanguageFormModel>(
        LanguageFormComponent.toFormModel(entity)
      );
      this._cd.detectChanges();
    });
  }

  private _save$() {
    const fv = this.formControl.value ?? [{ languageCode: Language.En, preferred: true }];

    return this._updateEntityBasicInfoGQL.mutate({
      input: {
        entityId: this.data.entityId,
        campaignId: this.data.campaignId,
        changes: {
          entityLanguages: fv.map(x => ({
            languageCode: x.languageCode,
            preferred: x.preferred
          }))
        }
      }
    });
  }
}
